import RxdbManager from '@/rxdb/RxdbManager';

import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { kind as stop } from '../../actions/goals/Stop';
import { toLegacyDB } from '../../Database';
import { reject, rejectAll, resolve } from '../../GoalResolvers';
import { State } from '../../State';
import { clean } from './clean';
import { destroy } from './destroy';
import { idle } from './idle';
import { suspend } from './suspend';

// Regardless of how it got there, certain states will make life cycle changes, such as:
// * Preparing a new task.
// * Dowgrading
// * Disabling

export function downgrade(state: State): State {
  let goalResolvers = state.goalResolvers;
  const reason = 'Downgrading';
  goalResolvers = reject(goalResolvers, restart, reason);
  goalResolvers = reject(goalResolvers, start, reason);
  goalResolvers = resolve(goalResolvers, stop);

  if (goalResolvers.Rebuild.length) {
    return clean({ ...state, goalResolvers });
  }

  if (goalResolvers.Destroy.length) {
    return destroy({ ...state, goalResolvers });
  }

  if (state.replication) {
    return suspend({ ...state, goalResolvers });
  }

  // There's no `async` calls during the downgrade, so we don't need a task.
  const manager = RxdbManager.legacyInstance;
  manager.db = state.database ? toLegacyDB(state.database) : undefined;
  manager.isInitialized = !!manager.db;
  // We will only downgrade if replication is suspended.
  manager.syncStates = [];
  manager.reSyncTimeouts = [];
  manager.syncActive = false;
  manager.syncCancelled = state.disabled;

  goalResolvers = rejectAll(goalResolvers, reason);

  return idle({ ...state, database: undefined, goalResolvers, legacy: true });
}
